export const PLANS_MAPPING = {
    // backend name: {UI extra attributes}
    // backend guarantees that name are not changed and can be used as keys
    pro_qsr: {displayName: "Pro QSR"},
    essentials_qsr: {displayName: "Essentials QSR"},
    pro_food_truck: {displayName: "Pro Food Truck"},
    essentials_food_truck: {displayName: "Essentials Food Truck"},
    digital: {displayName: "Digital"},
}
